import { render, staticRenderFns } from "./NotifiCations.vue?vue&type=template&id=19c8bf06"
import script from "./NotifiCations.vue?vue&type=script&lang=js"
export * from "./NotifiCations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports